import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { useAbility } from "@/shared/security";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";
import { HiddenLabel } from "@/shared/value";

export const Guard = {
  HiddenLabel: {
    IfCantRead: GuardHiddenLabelIfCantRead,
  },

  Redirect: {
    IfCantModify: {
      PageNotFound: GuardRedirectIfCantModifyPageNotFound,
    },
    IfCantRead: {
      PageNotFound: GuardRedirectIfCantReadPageNotFound,
    },
  },

  Hide: {
    IfCantRead: GuardHideIfCantRead,
    IfCantModify: GuardHideIfCantModify,
  },
};

function GuardHiddenLabelIfCantRead({
  children,
  influencedBy,
}: {
  children: ReactNode;
  influencedBy: AllTokens[];
}) {
  const { canRead } = useAbility(influencedBy);

  if (!canRead) {
    return <HiddenLabel />;
  }

  return children;
}

function GuardRedirectIfCantModifyPageNotFound({
  children,
  influencedBy,
}: {
  children: ReactNode;
  influencedBy: AllTokens[];
}) {
  const { canModify } = useAbility(influencedBy);

  if (!canModify) {
    return <ToPageNotFound />;
  }

  return children;
}

function GuardRedirectIfCantReadPageNotFound({
  children,
  influencedBy,
}: {
  children: ReactNode;
  influencedBy: AllTokens[];
}) {
  const { canRead } = useAbility(influencedBy);

  if (!canRead) {
    return <ToPageNotFound />;
  }

  return children;
}

function GuardHideIfCantRead({
  children,
  influencedBy,
}: {
  children: ReactNode | ((props: ReturnType<typeof useAbility>) => ReactNode);
  influencedBy: AllTokens[];
}) {
  const abilities = useAbility(influencedBy);

  if (!abilities.canRead) {
    return null;
  }

  return typeof children === "function" ? children(abilities) : children;
}

function GuardHideIfCantModify({
  children,
  influencedBy,
}: {
  children: ReactNode;
  influencedBy: AllTokens[];
}) {
  const { canModify } = useAbility(influencedBy);

  if (!canModify) {
    return null;
  }

  return children;
}
